import { DSNCImage, DSNCLinkedImage } from 'shared-definitions/types'
import { ApiComponentImageWithBadge } from 'data-source/types.wp'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { pLinkMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function ncImageWithBadge(
  input: ApiComponentImageWithBadge,
  opts: PLinkMapperOpts
): DSNCImage | DSNCLinkedImage | [] {
  const pLink = input.badge?.url ? pLinkMapper(input.badge.url, opts) : null
  const image = imageMapper(input.image, opts)
  const badge = imageMapper(input.badge, opts)
  const badges = badge ? [badge] : []
  if (!image) {
    return []
  }

  if (pLink) {
    return {
      resource: 'nc-linked-img',
      image,
      badges,
      pLink,
    }
  }
  return {
    resource: 'nc-img',
    image,
    badges,
  }
}
